export default {
  apartments: {
    breadcrumbHome: 'Početna',
    breadcrumbSolutions: 'Rješenja',
    breadcrumbCurrent: 'Višestambene zgrade i nekretnine',
    hero: {
      eyebrow: 'Višestambene zgrade i nekretnine',
      title: 'Sigurnost za cijele stambene zgrade',
      lead: 'Ulaz, stubište, podzemna garaža – planiramo nadzor za višestambene zgrade koji štiti stanare i daje mir vlasnicima.',
    },
    areas: {
      title: 'Točke nadzora u višestambenoj zgradi',
      lead: 'Zajedničke površine najvažnije su polazišne točke. Uvijek poštujemo prava svih stanara.',
      items: {
        '0': { title: 'Ulaz u zgradu', desc: 'Ulaz je vizitka zgrade i najvažnija točka nadzora. Kamere bilježe tko ulazi.' },
        '1': { title: 'Stubište', desc: 'Stubišta su prolazi s puno kretanja. Kompaktne kamere neprimjetno zatvaraju praznine među katovima.' },
        '2': { title: 'Podrum za bicikle', desc: 'Bicikli i e-bicikli česte su mete krađe. Nadzor odvraća i pomaže u razjašnjenju.' },
        '3': { title: 'Vanjske površine', desc: 'Igrališta, zelene površine i staze zajednički su. Kamere otporne na vremenske uvjete štite i ovdje.' },
        '4': { title: 'Podzemna garaža', desc: 'Parkirna mjesta u podzemnoj garaži ugrožena su noću. Dobro osvijetljen nadzor stvara sigurnost.' },
        '5': { title: 'Poštanski sandučići', desc: 'Sandučići i pretinci za pakete ključni su za krađu paketa. Kamere na pristupu značajno pomažu.' },
      },
    },
    protection: {
      eyebrow: 'Zaštita podataka i kućni red',
      title: 'Nadzirati bez povrede',
      lead: 'U višestambenoj zgradi isprepliću se mnogi interesi. Nadzor provodimo tako da poštuje privatnost stanara i ostaje zakonski čist.',
      items: {
        '0': { title: 'Maskiranje privatnih zona', desc: 'Prozori, vrata stanova i privatna područja tehnički se skrivaju – ostaju samo zajedničke površine.' },
        '1': { title: 'Odluka i kućni red', desc: 'Videonadzor u višestambenoj zgradi traži čvrstu osnovu. Podržavamo vas u čistoj provedbi.' },
        '2': { title: 'Oznake', desc: 'Jasne oznake na ulazu informiraju stanare i posjetitelje – transparentno i pošteno.' },
      },
    },
    value: {
      eyebrow: 'Dodana vrijednost',
      title: 'Prednosti za vlasnike i upravitelje',
      lead: 'Dobro osmišljen sustav isplati se svima: stanari se osjećaju sigurnije, vlasnici štite imovinu, a upravitelji dobivaju jasnoću.',
      list: {
        '0': 'Pristup za upravitelje i vlasnike s odvojenim pravima',
        '1': 'Snimanje posljednjih dana do tjedana – ovisno o konfiguraciji',
        '2': 'Rasterećenje uprave u incidentima i sporovima',
        '3': 'Potpuna dokumentacija kod vandalizma ili provale',
        '4': 'Odvraćanje neovlaštenog pristupa',
        '5': 'Veći osjećaj sigurnosti za stanare i vlasnike',
      },
      note: 'Napomena: zakonska dopuštenost videonadzora u stambenim zgradama snažno ovisi o slučaju. Savjetujemo vas, ne zamjenjujući pravni savjet.',
    },
    cta: {
      title: 'Više sigurnosti za vašu zgradu',
      lead: 'Savjetujemo suvlasničke zajednice i upravitelje bez obveze – od prve ideje do sustava ključ u ruke.',
      primary: 'Zakažite termin savjetovanja',
      secondary: 'Pokrenite planer kamera',
    },
  },
};